import { render, staticRenderFns } from "./administrator.vue?vue&type=template&id=2b3a473e"
import script from "./administrator.vue?vue&type=script&lang=js"
export * from "./administrator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports